// Import react elements
import { useContext } from "react";

// Import context function
import { AuthContext } from "global/context/AuthContext";
import { UserContext } from "global/context/UserContext";

// Import hooks
import usePageTitle from "global/hooks/usePageTitle";

// Import components
import { Grid, GridItem } from "global/components/Grid";
import OrdersList from "./components/Orders";

// Import css stylesheet
import "./OrdersPage.css";


// OrdersPage.js
const Orders = () => {



    // Set title inside the page
    usePageTitle("Orders"); 



    // Get the token from AuthContext
    const { token, authReady } = useContext(AuthContext);

    // Get connections data
    const { userDataErrorMessage } = useContext(UserContext);


    // If there is a user account data error then stop and display it
    if (userDataErrorMessage) {

        return (

            <Grid>
                            
                <GridItem>

                    <div className="dashboard-status-panel dashboard-status-panel--error">

                        <h3>Orders unavailable</h3>
                        <p>{userDataErrorMessage}</p>

                    </div>

                </GridItem>

            </Grid>

        );

    }


    return (

        <Grid>

            <OrdersList token={token} authReady={authReady} />

        </Grid>

    );

};

export default Orders;